/* eslint-disable react/react-in-jsx-scope */
import ReactDOM from "react-dom/client";
import React from "react";
import App from "./App";
import "./index.scss";
import { notification } from "antd";

// Service worker registration
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then((registration) => {
        console.log(
          "Service Worker registered with scope:",
          registration.scope
        );
      })
      .catch((error) => {
        console.error("Service Worker registration failed:", error);
      });

    // Register the Firebase Messaging service worker
    navigator.serviceWorker
      .register("/firebase-messaging-sw.js")
      .then((registration) => {
        console.log(
          "Firebase Messaging Service Worker registered with scope:",
          registration.scope
        );
      })
      .catch((error) => {
        console.error(
          "Firebase Messaging Service Worker registration failed:",
          error
        );
      });
  });
}

const loadFonts = async () => {
  const fonts = [
    {
      fontName: "Malgun Gothic",
      fontUrl: "malgun/MALGUN.ttf",
      weight: "normal",
      style: "normal",
    },
    {
      fontName: "Malgun Gothic",
      fontUrl: "malgun/MALGUNBD.ttf",
      weight: "bold",
      style: "normal",
    },
    {
      fontName: "Malgun Gothic",
      fontUrl: "malgun/MALGUNSL.ttf",
      weight: "300",
      style: "normal",
    },
    {
      fontName: "Gulim",
      fontUrl: "gulim/GULIM.ttc",
      weight: "normal",
      style: "normal",
    },
  ];

  try {
    for (const { fontName, fontUrl, weight, style } of fonts) {
      const font = new FontFace(
        fontName,
        `url(${process.env.PUBLIC_URL}/fonts/${fontUrl})`,
        { weight, style }
      );

      await font.load().catch((err) => {
        throw new Error(
          `Failed to load font "${fontName}" from ${fontUrl}: ${err.message}`
        );
      });

      document.fonts.add(font);
    }

    document.body.style.fontFamily =
      "Malgun Gothic, Times New Roman, sans-serif";
  } catch (err) {
    console.error("Font loading failed:", err.message);
  }
};

loadFonts();

ReactDOM.createRoot(document.getElementById("root")).render(<App />);

// test
